import types from '../actions/types';

import {
    singleResultReducer,
    singleResultInitialState
} from './common/single-result';

const initial_state = {
    statistics: singleResultInitialState
}

export default function(state = initial_state, action) {
    return {
        ...state,
        statistics: singleResultReducer(state.statistics, types.LOAD_STATISTICS, action)
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/statistics.js